import { Card, CardContent } from '@/components/ui/card';
import { LucideIcon } from 'lucide-react';

interface OnboardingOverviewCardProps {
  icon: LucideIcon;
  title: string;
  body: string;
}

export function OnboardingOverviewCard({ icon: Icon, title, body }: OnboardingOverviewCardProps) {
  return (
    <Card className="border-primary/20 bg-primary/5 backdrop-blur">
      <CardContent className="p-4 md:p-6">
        <div className="flex items-start gap-3">
          <div className="p-2 rounded-lg bg-primary/10 shrink-0">
            <Icon className="h-5 w-5 text-primary" />
          </div>
          <div className="space-y-2">
            <h3 className="font-semibold text-foreground">{title}</h3>
            <p className="text-sm text-muted-foreground leading-relaxed">{body}</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
